// extracted by css-extract-rspack-plugin
module.exports =  {"item":"AssessmentSection__item___SqpQI","label":"AssessmentSection__label___JRQf1","value":"AssessmentSection__value___oKVdD"};